import Swiper, { Navigation, Autoplay } from 'swiper'

Swiper.use([Navigation, Autoplay])
class CountView {
	constructor() {
		this.heightContent = 0
		this.sendAjax = false
		this.zoom_wrap()
		this.countView()
	}
	countView() {
		// if(this.heightContent) {
		let _this = this
		let t0 = performance.now()
		setTimeout(() => {
			if (typeof URL_COUNT_VIEW !== undefined) {
				let t1 = performance.now()
				_this.sendAjax = true
				fetch(URL_COUNT_VIEW, {
					method: 'POST', // or 'PUT'
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						idArticle: articleID,
						time: TIME,
						time_reader: (t1 - t0) / 1000,
						user_agent: navigator.userAgent,
					}),
				})
					.then((response) => response.json())
					.then((response) => {
						console.log(response)
					})
					.catch((error) => {
						console.log(error)
					})
			}
		}, 3000)
		// }
	}

	getHeightContent() {
		let heightContent = document.querySelector('#abody').offsetHeight
		this.heightContent = heightContent
		return heightContent
	}

	zoom_wrap() {
		try {
			let maincontent = document.querySelector('#maincontent')
			let imgs = maincontent?.querySelectorAll('img')
			let imgHtml = ''
			let zoom_wrap = null
			let zoom_swiper = null
			imgs.forEach((img) => {
				let maximize_button =
					'<span class="absolute top-0 right-0 w-16 h-16 bg-[rgba(0,0,0,.08)] hover:bg-[rgba(0,0,0,.5)] flex justify-center items-center cursor-pointer open-img-full"><svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="w-10 h-10 stroke-white"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg></span>'
				let img_wrap = img.parentElement

				let caption = img_wrap?.closest('tbody')?.querySelector('.caption') || img_wrap?.closest('tbody')?.querySelector('.alt_imgEditor') || img_wrap?.querySelector('figcaption')
				
				img_wrap.classList.add('cursor-pointer')
				// img_wrap.insertAdjacentHTML('beforeend', maximize_button)
				img.classList.add('mx-auto', 'max-w-full' , 'w-[1000px]',  'h-auto')
				let imgWrap = `<div class="swiper-slide">
				<div>${img.outerHTML}
				<div class="text-center text-white mt-3 px-5 max-w-[800px] mx-auto">${caption? caption.innerHTML : ''}</div></div>
				</div>`
				imgHtml += imgWrap
			})
			// let btn_open_img_full = maincontent?.querySelectorAll('.open-img-full')
			imgs.forEach((img) => {
				img.addEventListener('click', (e) => {
					e.preventDefault()
				})
			})
			imgs.forEach((item, i) => {
				item.addEventListener('click', (e) => {
					e.preventDefault()
					let swiperHtml = `<div class="swiper zoom"><div class="swiper-wrapper relative">${imgHtml}</div>
					<div class="next-button swiper-button-next after:content-[''] fixed top-1/2 -right-11 xl:right-10 transform -translate-y-1/2 w-28 h-28">
					<svg viewBox="0 0 24 24" width="36" height="36" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="stroke-[#ccc] xl:stroke-white w-16 h-16"><polyline points="9 18 15 12 9 6"></polyline></svg>
					</div>
					<div class="prev-button swiper-button-prev after:content-[''] fixed top-1/2 -left-11 xl:left-10 transform -translate-y-1/2 w-28 h-28">
					<svg viewBox="0 0 24 24" width="36" height="36"  stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="stroke-[#ccc] xl:stroke-white w-16 h-16"><polyline points="15 18 9 12 15 6"></polyline></svg>
					</div>
					</div>`
					zoom_wrap = document.createElement('div')
					zoom_wrap.classList.add('fixed', 'top-0', 'left-0', 'right-0', 'bottom-0', 'z-[19999]', 'bg-[rgba(0,0,0,.95)]', 'flex', 'justify-center', 'items-center')
					let closeBtn =
						'<svg viewBox="0 0 24 24"  stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="w-10 h-10 stroke-white absolute top-10 right-10 z-[200000] close"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>'
					zoom_wrap.insertAdjacentHTML('afterbegin', swiperHtml)
					zoom_wrap.insertAdjacentHTML('afterbegin', closeBtn)
					maincontent.append(zoom_wrap)
					zoom_swiper = new Swiper('.swiper.zoom', {
						slidesPerView: 1,
						loop: true,
						autoHeight: true,
						initialSlide: i,
						navigation: {
							nextEl: '.next-button.swiper-button-next',
							prevEl: '.prev-button.swiper-button-prev',
						},
					})
					zoom_wrap.querySelector('.close').addEventListener('click', () => {
						if (!zoom_wrap.classList.contains('hidden')) {
							zoom_wrap.classList.add('hidden')
							zoom_swiper.destroy()
						}
					})
					if (zoom_wrap && zoom_wrap.classList.contains('hidden')) {
						zoom_wrap.classList.remove('hidden')
					}
				})
			})
		} catch (error) {
			console.log('CountView.zoom_wrap', { message: error.message })
		}
	}
}

window.addEventListener('DOMContentLoaded', function () {
	new CountView()
})
